import { Body, FormatUtils, useLocales } from "@/lib/main";
import { DonutChartFigCaptionLinePropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";
import { CSSProperties } from "react";

export default function DonutChartFigCaptionLine({
  units,
  label,
  value,
  total,
  color,
  showPercentages,
}: DonutChartFigCaptionLinePropTypes) {
  const l = useLocales();

  const legendListItemStyle: CSSProperties = {
    display: "contents",
  };

  const spanStyle: CSSProperties = {
    backgroundColor: `var(--color-${color}-500)`,
    borderRadius: "var(--border-radius-2xs)",
    height: "0.75rem",
    width: "0.75rem",
    alignSelf: "center",
    justifySelf: "start",
  };

  const labelStyle: CSSProperties = {
    justifySelf: "start",
  };

  const valueStyle: CSSProperties = {
    justifySelf: "end",
  };

  const percentageStyle: CSSProperties = {
    justifySelf: "end",
  };

  return (
    <li style={legendListItemStyle}>
      <span style={spanStyle} />

      <Body size="sm" fontWeight={400} style={labelStyle}>
        {l(label)}
      </Body>

      {/* empty div to leave space for gap */}
      <div />

      <Body size="sm" fontWeight={400} style={valueStyle}>
        {FormatUtils.formatCompactNumber(value)}
        {units ? ` ${l(units)}` : ""}
      </Body>

      {showPercentages && (
        <Body size="sm" fontWeight={400} color="assist" style={percentageStyle}>
          {((value / (total + 0)) * 100).toFixed(0)}%
        </Body>
      )}
    </li>
  );
}
